const initialState = {
  list: [],
  loading: 'idle',

  selectedItem: {
    data: null,
    loading: 'idle',
  },

  options: {
    data: {
      finishedGoodTypes: {
        data: [],
        loading: 'idle',
      },
    },
    loading: 'idle',
  },

  productBrands: {
    data: [],
    loading: 'idle',
  },
};

export default initialState;
